import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import * as alertify from "alertifyjs";
import { Constant } from '../../Constant';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import { map, Subject, take, takeUntil, takeWhile, timer } from 'rxjs';

@Component({
  selector: 'app-session-dialog',
  templateUrl: './session-dialog.component.html',
  styleUrls: ['./session-dialog.component.css']
})
export class SessionDialogComponent implements OnInit {

  @Input() header = 'Inactive Session';
  @Input() body = 'Your session is about to expire due to inactivity.';
  @Input() positiveButtonText = 'Continue session';
  @Input() negativeButtonText = 'Log out';
  @Input() dismissOnActionSelect = true;
  @Input() showCancel = true;
  @Input() showLoadingOnActionClick = true;
  @Output() onExitClicked = new EventEmitter();
  @Output() onRefreshClicked = new EventEmitter();
  @Input() loading = false;
  @Input() set autoLogOutTimeMs(value: number) {
    this.timeoutMs = value;
  };

  timeoutMs = 30 * 1000; // 30 seconds
  private readonly _destroy$ = new Subject<void>();

  get seconds() {
    return Math.floor(this.timeoutMs / 1000);
  }

  get minutes() {
    return Math.floor(this.seconds / 60);
  }

  get displaySeconds() {
    return Math.max(0, this.seconds % 60).toString().padStart(2, '0');
  }

  get displayMinutes() {
    return Math.max(0, this.minutes % 60).toString().padStart(2, '0');
  }

  get isCritical() {
    return this.timeoutMs <= (10 * 1000);
  }

  constructor(
    public modalRef: BsModalRef, 
    private readonly toastr: ToastrService,
    private readonly apiService: ApiServiceService
  ) {}

  ngOnInit(): void {
    console.log(this.timeoutMs)
    this.initCounter();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  initCounter(interval: number = 1000) {
    timer(0, interval).pipe(
      takeWhile(tick => this.timeoutMs > tick, true),
      // Stop if component destroyed or user manually closes modal
      takeUntil(this._destroy$)
    ).subscribe({
      next: (value) => {
        this.timeoutMs -= interval;
        if (this.timeoutMs <= 0) this.exit();
      },
    });
  }

  close() {
    this._destroy$.next();
    this.modalRef.hide();
  }

  exit() {
    if (this.showLoadingOnActionClick) {
      this.loading = true;
    }
    if (this.dismissOnActionSelect) {
      this.close();
    }
    this.onExitClicked.emit();
  }

  refresh() {
    if (this.showLoadingOnActionClick) {
      this.loading = true;
    }

    const payload = {
      refreshToken: JSON.parse(JSON.stringify(localStorage.getItem(Constant.REFRESH_TOKEN)))
    };

    this._destroy$.next();
    this.apiService.post('/auth/refresh-token', payload).subscribe({
      next: (res: {token: string, refreshToken: string, message: string}) => {
        if (!res.token) {
          alertify.set("notifier", "position", "top-right");
          alertify.error(res.message);
        } else {
          localStorage.setItem(Constant.LOGGED_IN_USER, res.token);
          localStorage.setItem(Constant.REFRESH_TOKEN, res.refreshToken);
          localStorage.setItem(
            Constant.SESSION_TIMER,
            JSON.stringify(
              moment(Date.now()).add(1, "hours").subtract(30, "minutes")
            )
          );
        }
        
        this.onRefreshClicked.emit();
        if (this.dismissOnActionSelect) {
          this.close();
        }
      },
      error: (error) => {
        this.toastr.error(error.error.message || Constant.ERROR_OCCURED, "Error", { positionClass: "toast-top-center" });
        this.onRefreshClicked.emit();
        if (this.dismissOnActionSelect) {
          this.close();
        }
      },
    });
  }
}
